import {
  DeleteJobCatalogTreeNodeDocument,
  DeleteJobCatalogTreeNodeMutation,
  JobCatalogTreePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteJobCatalogTreeNode = () => {
  const [mutate, { loading }] = useMutation(DeleteJobCatalogTreeNodeDocument, {
    extractorFn: (data: DeleteJobCatalogTreeNodeMutation) =>
      data.jobCatalogMutations.deleteJobcatalogTreeNode,
    refetchQueries: [JobCatalogTreePageDocument],
    awaitRefetchQueries: false,
  })

  const deleteNode = (nodeUuid: string) => {
    return mutate({
      variables: {
        node_uuid: nodeUuid,
      },
    })
  }

  return { deleteNode, loading }
}
